import React from "react";
import { CounterListItem } from "../atoms/CountersListItem";
import { queryCurrAccCounters, $currAccCounters, queryUpdateCurrAccCounters } from "../logics/counters";
import { useStore } from "effector-react";
import { empty } from "../../../common/functions";
import {
  $selectedAccountId,
  $selectedAccountIdx,
  $accounts,
} from "../../../common/accounts2";

import "../styles/Counters.css";

export const CountersBlock = () => {
  const accId = useStore($selectedAccountId);
  const accIdx = useStore($selectedAccountIdx);
  const counters = useStore($currAccCounters);
  const { accounts } = useStore($accounts); //список аккаунтов
  React.useEffect(() => {
    if ( accIdx > -1 && accounts[accIdx].companyId !== 34) queryCurrAccCounters(accId)
    .then(res => {if(res!==undefined)res.forEach(elem => queryUpdateCurrAccCounters(elem))});
  }, [accId, accId]);

  if (accIdx > -1 && accounts[accIdx].companyId === 34) return <></>;
  else
    return accIdx < 0 || empty(accounts) || empty(counters) ? (
      <div className="page__data-card">
        <p className="data-card__text">Счетчики не найдены</p>
      </div>
    ) : (
      <div className="page__data-card">
        <h2 className="data-card__title">Счетчики</h2>
        <ul className="counters__list">
          {counters.map((counter, i) => (
            <CounterListItem
              id={counter.id}
              key={i}
              canSend={counter.canSend}
              typeName={counter.nameType}
              number={counter.serialNumber}
              value ={counter.counter_value}
              dateLastVerif={counter.last_stamp}
            />
          ))}
        </ul>
      </div>
    );
};
